export default "__VITE_ASSET__Ca$iByBc__"